import { eManulSortLayerDrawOrder, eTextures, Game } from "../../Game";
import { eSprite, SPRITES } from "../../Sprites";
import { TIMER } from "../Gameplay";


export class TargetHitFx {
    private static readonly ANIM_NAME = "def";

    private _entity: pc.Entity;

    get isActive(): boolean { return this._isActive; }
    private _isActive: boolean;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        this._entity = new pc.Entity();
        this._entity.addComponent(pc.eCompomentType.sprite, {
            layers: [Game.manualSortLayer.id],
            drawOrder: eManulSortLayerDrawOrder.targetHitFx,
        });

        let anim = this._entity.sprite.addClip({
            fps: 15,
            loop: false,
            name: TargetHitFx.ANIM_NAME,
            spriteAsset: SPRITES[eSprite.hitFx].getSpriteAssetId()
        });

        Game.app.root.addChild(this._entity);
        anim.on("end", this.handleAnimClipEnd, this);
        this.reset();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        this._entity.enabled = false;
        this._isActive = false;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    activate(pos: pc.Vec3): void {
        this._entity.setPosition(pos);
        this._entity.sprite.stop();
        this._entity.sprite.play(TargetHitFx.ANIM_NAME);
        this._entity.enabled = true;

        this._isActive = true;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleAnimClipEnd(): void {
        this.reset();
    }
}
